/*! Copyright (c) Safe As Milk. All rights reserved. */
class ProductSingle extends HTMLElement {
    #variant;
    connectedCallback() {
        this.mediaGallery = this.querySelector("media-gallery");
        this.#moveModalsFromStickyScrollContainer();
        // Gaia: clicking/swiping to a variant's image selects that variant (and its Hörprobe)
        this.addEventListener("on:media-carousel:slide-change", this.#selectVariantFromSlide.bind(this), true);
    }
    #selectVariantFromSlide({detail: {currentSlide: currentSlide}}) {
        const picker = this.querySelector("variant-radios, variant-selects, variant-mixed-inputs");
        if (!picker || !currentSlide) return;
        const mediaId = Number(currentSlide.dataset.mediaId || currentSlide.querySelector("[data-media-id]")?.dataset.mediaId);
        if (!mediaId) return;
        const variant = picker.getVariantData().find((v => v.featured_media && v.featured_media.id === mediaId));
        if (!variant) return;
        picker.updateOptions();
        picker.updateMasterId();
        if (picker.currentVariant && picker.currentVariant.id === variant.id) return;
        let changed;
        Array.from(picker.querySelectorAll("fieldset, select")).forEach(((group, index) => {
            const value = variant.options[index];
            if (group.tagName === "SELECT") {
                if (group.value !== value) {
                    group.value = value;
                    changed = group;
                }
                return;
            }
            const input = Array.from(group.querySelectorAll("input")).find((i => i.value === value));
            if (input && !input.checked) {
                input.checked = true;
                changed = input;
            }
        }));
        if (changed) changed.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
    updateMedia() {
        if (!this.mediaGallery || !this.#variant.featured_media) return;
        const mediaId = this.#variant.featured_media.id;
        this.mediaGallery.goToSlide(mediaId);
    }
    set variant(variant) {
        this.#variant = variant;
        this.updateMedia();
    }
    get variant() {
        return this.#variant;
    }
    #moveModalsFromStickyScrollContainer() {
        const modals = this.querySelectorAll("sticky-scroll modal-dialog, sticky-scroll popup-dialog");
        modals.forEach((modal => {
            this.append(modal);
        }));
    }
}

customElements.define("product-single", ProductSingle);
//# sourceMappingURL=product-single.js.map
